var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section-faq",class:{
    [`section${_vm.orderNo}`]: true,
    'light-content-theme': _vm.contentTheme === 'light'
  },style:({ backgroundColor: _vm.backgroundColor })},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),(_vm.data.title || _vm.data.subtitle)?_c('div',{staticClass:"top-title"},[_c('AtomsCommonAtomTitle',{attrs:{"title":_vm.$tdb(_vm.data.title),"subtitle":_vm.$tdb(_vm.data.subtitle)}})],1):_vm._e(),_vm._v(" "),_c('FAQAccordion',{attrs:{"items":_vm.data.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }